export default __webpack_public_path__ + "static/media/system1.9a819f3f.png";